import { AbstractControl, FormGroup } from '@angular/forms';

export function markAsTouchDeep(formGroup: FormGroup | AbstractControl) {
  (<any>Object).values((formGroup as FormGroup).controls).forEach((control: AbstractControl) => {
    control.markAsTouched();

    if (control['controls']) {
      markAsTouchDeep(control);
    }
  });
};